// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personal-cabinet-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
  min-height: 100vh;
}

.cabinet-content {
  max-width: 1200px;
  margin: 0 auto;
}

.info-card {
  background: white;
  border-radius: 16px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
  overflow: hidden;
}

.card-header {
  padding: 15px 28px 15px 28px;
  border-bottom: 1px solid #eef2f6;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0;
}

.back-button {
  background: none;
  border: 1px solid #002FA7;
  color: #002FA7;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.back-button:hover {
  color: #002FA7;
}

.staff-info-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  padding: 20px 28px 20px 28px;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-field label {
  font-size: 13px;
  font-weight: 500;
  color: #002FA7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.field-value {
  font-size: 16px;
  font-weight: 500;
  color: #1a1a2e;
  padding: 8px 0;
  border-bottom: 2px solid #eef2f6;
}

.email-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
}

.email-value {
  flex: 1 1;
  word-break: break-all;
}

.edit-email-btn {
  background: none;
  border: 1px solid #002FA7;
  color: #002FA7;
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.edit-email-btn:hover {
  background: #002FA7;
  color: white;
}

.email-edit {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.email-input {
  padding: 10px 14px;
  border: 1px solid #e0e5ec;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.2s;
  background: white;
  width: 100%;
  box-sizing: border-box;
}

.email-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.email-edit-actions {
  display: flex;
  gap: 12px;
}

.save-email-btn {
  background: #002FA7;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.save-email-btn:hover:not(:disabled) {
  background: #001f7a;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.3);
}

.save-email-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.cancel-email-btn {
  background: none;
  border: 1px solid #ccc;
  color: #666;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-email-btn:hover {
  border-color: #999;
  color: #333;
}

.groups-section {
  background: white;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.groups-section h2 {
  font-size: 22px;
  font-weight: 600;
  color: #002FA7;
  margin: 0 0 24px 0;
  padding-bottom: 16px;
  border-bottom: 2px solid #eef2f6;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.course-column {
  background: #fafbff;
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s;
}

.course-column:hover {
  box-shadow: 0 2px 12px rgba(0, 47, 167, 0.1);
}

.course-column h3 {
  font-size: 18px;
  font-weight: 600;
  color: #002FA7;
  margin: 0 0 16px 0;
  text-align: center;
  padding-bottom: 8px;
  border-bottom: 2px solid #002FA7;
  display: inline-block;
  width: 100%;
}

.groups-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.group-item {
  background: white;
  padding: 10px 8px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  color: #002FA7;
  border: 1px solid #e0e5ec;
  transition: all 0.2s;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-item:hover {
  background: #f0f4ff;
  border-color: #002FA7;
  transform: translateY(-1px);
}

.cs-loading {
  text-align: center;
  padding: 60px 20px;
  color: #002FA7;
  font-size: 18px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/md-components/PersonalCabinetMetodist.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".personal-cabinet-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px;\n  min-height: 100vh;\n}\n\n.cabinet-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.info-card {\n  background: white;\n  border-radius: 16px;\n  padding: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  margin-bottom: 32px;\n  overflow: hidden;\n}\n\n.card-header {\n  padding: 15px 28px 15px 28px;\n  border-bottom: 1px solid #eef2f6;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 0;\n}\n\n.back-button {\n  background: none;\n  border: 1px solid #002FA7;\n  color: #002FA7;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n}\n\n.back-button:hover {\n  color: #002FA7;\n}\n\n.staff-info-wrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 48px;\n  padding: 20px 28px 20px 28px;\n}\n\n.info-column {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.info-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.info-field label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #002FA7;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.field-value {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1a1a2e;\n  padding: 8px 0;\n  border-bottom: 2px solid #eef2f6;\n}\n\n.email-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.email-value {\n  flex: 1;\n  word-break: break-all;\n}\n\n.edit-email-btn {\n  background: none;\n  border: 1px solid #002FA7;\n  color: #002FA7;\n  padding: 6px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.edit-email-btn:hover {\n  background: #002FA7;\n  color: white;\n}\n\n.email-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.email-input {\n  padding: 10px 14px;\n  border: 1px solid #e0e5ec;\n  border-radius: 10px;\n  font-size: 14px;\n  transition: all 0.2s;\n  background: white;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.email-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.email-edit-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.save-email-btn {\n  background: #002FA7;\n  color: white;\n  border: none;\n  padding: 8px 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.save-email-btn:hover:not(:disabled) {\n  background: #001f7a;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.3);\n}\n\n.save-email-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.cancel-email-btn {\n  background: none;\n  border: 1px solid #ccc;\n  color: #666;\n  padding: 8px 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancel-email-btn:hover {\n  border-color: #999;\n  color: #333;\n}\n\n.groups-section {\n  background: white;\n  border-radius: 16px;\n  padding: 28px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.groups-section h2 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0 0 24px 0;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #eef2f6;\n}\n\n.courses-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n}\n\n.course-column {\n  background: #fafbff;\n  border-radius: 12px;\n  padding: 16px;\n  transition: all 0.2s;\n}\n\n.course-column:hover {\n  box-shadow: 0 2px 12px rgba(0, 47, 167, 0.1);\n}\n\n.course-column h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0 0 16px 0;\n  text-align: center;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #002FA7;\n  display: inline-block;\n  width: 100%;\n}\n\n.groups-list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.group-item {\n  background: white;\n  padding: 10px 8px;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 14px;\n  color: #002FA7;\n  border: 1px solid #e0e5ec;\n  transition: all 0.2s;\n  cursor: default;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.group-item:hover {\n  background: #f0f4ff;\n  border-color: #002FA7;\n  transform: translateY(-1px);\n}\n\n.cs-loading {\n  text-align: center;\n  padding: 60px 20px;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
